module.exports = __webpack_public_path__ + "static/img/cinema-13.9f15654.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img/cinema-13.png
// module id = 1383
// module chunks = 4